import React from 'react';
import CopyrightYear from '../CopyrightYear';
import Image from "next/image";
import Link from "next/link";

const FooterDesktop = () => {
  return (
    <div className="container mx-auto px-4">
      <div className="flex flex-row items-center justify-between py-3">
        <div className="flex items-center space-x-4">
          <Link href="/" className="flex-shrink-0">
            <Image
              src="/images/logo/logo-2.png"
              alt="logo"
              className="w-28 dark:hidden"
              width={140}
              height={30}
              priority
            />
            <Image
              src="/images/logo/logo.png"
              alt="logo"
              className="hidden w-28 dark:block"
              width={140}
              height={30}
              priority
            />
          </Link>
          <p className="text-xs text-gray-600 dark:text-gray-400 max-w-md">
            7 Avenue de Laponie - ZA Courtaboeuf - 91940 Les Ulis R.C.S 953 965 332
          </p>
        </div>

        <Link
          href="/"
          className="text-xs text-gray-600 hover:text-primary dark:text-gray-400 dark:hover:text-primary transition-colors"
        >
          Privacy Policy
        </Link>
      </div>

      <div className="border-t border-gray-200 dark:border-gray-800">
        <div className="py-3">
          <p className="text-center text-xs text-gray-600 dark:text-gray-400">
            © <CopyrightYear />{" "}
            <a
              href="https://deltaalgosystem.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-primary transition-colors"
            >
              Delta AlgoSystem
            </a>{" "}
            - All Rights Reserved
          </p>
        </div>
      </div>
    </div>
  );
};

export default FooterDesktop; 